<template>
  <HeaderComponent/>
  <div class="page">
      <main class="workspace">
        <StatWindow></StatWindow>
      </main>
  </div>
</template>
  
<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import StatWindow from '@/components/StatWindow.vue';

export default {
    name: "StatView",
    components: {
        HeaderComponent,
        StatWindow
    },
    data(){
        return{
        }
    }
}
</script>
<style scoped>
.page{
  height:90vh;
  background:#111315;
  color:white;
  display:flex;
  flex-direction:column;
}

.workspace{
  flex:1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap:32px;
  padding-top:40px;
  padding-left: 40px;
  padding-right: 40px;
  height: 100%;
}
</style>